import { Line } from 'vue-chartjs'
export default {
  extends: Line,
  props: ['chart', 'display'],
  watch: {
    chartData: function () {
      this.renderChart({
        labels: this.chart.labels,
        datasets: this.chart.datasets,
      }, {
        responsive: true, maintainAspectRatio: false, legend: {
          display: this.display
        },
      });
    }
  },
  mounted() {

    if(this.chart==null)
    return;

    this.renderChart({
      labels: this.chart.labels,
      datasets: this.chart.datasets,
    }, {
      responsive: true, maintainAspectRatio: false, legend: {
        display: this.display
      },
    })
  }
}